import type { AppLanguage } from './types';

const GOOGLE_CALENDAR_ACCOUNT_HINT: Record<AppLanguage, string> = {
  en: 'Google Calendar uses whichever Google account is signed into this browser—not your Placy login. Switch accounts in Google, or download .ics to import elsewhere.',
  he: 'Google Calendar משתמש בחשבון Google שמחובר בדפדפן הזה—לא בחשבון Placy. החליפו חשבון ב-Google, או הורידו קובץ .ics לייבוא ליומן אחר.',
};

export function googleCalendarAccountHint(language: AppLanguage): string {
  return GOOGLE_CALENDAR_ACCOUNT_HINT[language] ?? GOOGLE_CALENDAR_ACCOUNT_HINT.en;
}
